import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Pricing = () => {
  useEffect(() => {
    // Initialize scripts if needed
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main>

      <section className="ul-breadcrumb ul-section-spacing">
        <div className="ul-container">
          <h2 className="ul-breadcrumb-title">Pricing</h2>
          <ul className="ul-breadcrumb-nav">
            <li><Link to="/">Home</Link></li>
            <li>
              <span className="separator"><i className="flaticon-right"></i></span>
            </li>
            <li>Pricing</li>
          </ul>
        </div>
      </section>

      <section className="ul-pricing ul-section-spacing">
        <div className="ul-container">
          <div className="row ul-bs-row row-cols-lg-3 row-cols-sm-2 row-cols-1">

            <div className="col">
              <div className="ul-pricing-package">

                <div className="ul-pricing-package-heading">
                  <span className="ul-pricing-package-name">Basic</span>
                  <div className="ul-pricing-package-heading-bottom">
                    <h3 className="ul-pricing-package-price">$19</h3>
                    <div className="right">
                      <span className="ul-pricing-package-duration"
                        ><span className="divider">/</span>Month</span
                      >
                    </div>
                  </div>
                  <p className="ul-pricing-package-descr">
                    We care about their success. For us real We care about their
                    success. For us real relationship.
                  </p>
                </div>

                <div className="ul-pricing-package-body">
                  <ul className="ul-pricing-package-body-list">
                    <li>Providing solutions</li>
                    <li>Service that matters</li>
                    <li>Giving our best</li>
                    <li>24/7 Skilled Support</li>
                    <li>We serve differently</li>
                  </ul>

                  <Link to="/contact" className="ul-pricing-package-btn">Choose a Plan</Link>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="ul-pricing-package">

                <div className="ul-pricing-package-heading">
                  <span className="ul-pricing-package-name">Standard</span>
                  <div className="ul-pricing-package-heading-bottom">
                    <h3 className="ul-pricing-package-price">$59</h3>
                    <div className="right">
                      <span className="ul-pricing-package-duration"
                        ><span className="divider">/</span>Month</span
                      >
                    </div>
                  </div>
                  <p className="ul-pricing-package-descr">
                    We care about their success. For us real We care about their
                    success. For us real relationship.
                  </p>
                </div>

                <div className="ul-pricing-package-body">
                  <ul className="ul-pricing-package-body-list">
                    <li>Providing solutions</li>
                    <li>Service that matters</li>
                    <li>Giving our best</li>
                    <li>24/7 Skilled Support</li>
                    <li>We serve differently</li>
                  </ul>

                  <Link to="/contact" className="ul-pricing-package-btn">Choose a Plan</Link>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="ul-pricing-package">

                <div className="ul-pricing-package-heading">
                  <span className="ul-pricing-package-name">Premium</span>
                  <div className="ul-pricing-package-heading-bottom">
                    <h3 className="ul-pricing-package-price">$110</h3>
                    <div className="right">
                      <span className="ul-pricing-package-duration"
                        ><span className="divider">/</span>Month</span
                      >
                    </div>
                  </div>
                  <p className="ul-pricing-package-descr">
                    We care about their success. For us real We care about their
                    success. For us real relationship.
                  </p>
                </div>

                <div className="ul-pricing-package-body">
                  <ul className="ul-pricing-package-body-list">
                    <li>Providing solutions</li>
                    <li>Service that matters</li>
                    <li>Giving our best</li>
                    <li>24/7 Skilled Support</li>
                    <li>We serve differently</li>
                  </ul>

                  <Link to="/contact" className="ul-pricing-package-btn">Choose a Plan</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

      <Footer />
    </>
  );
};

export default Pricing;
